import state from './state';
import Store from '../../base';


export default class InvoiceTemplates extends Store {
    constructor(model, ng){

        state.model = model;

        super({state, ng});
    }
}


// WEBPACK FOOTER //
// ./src/app/store/billing/invoice_templates/index.js